function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}${month}`;
}
function formatDateToYYYYMMDDHHMMSS(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
export default {
    loading: {
        module: false
    },
    params: {
       date : formatDate(new Date()),
       account_id : null,
       type_balance : null,
       value_compare : null,
    },
    accounts_form: [],
    accounts_voucher: [],
    contacts:[],
    conciliation_balances:[],
    branchoffices:[],
    balance_conciliation:[],
    warehouses:[],
    ag_grid: {
        selectedTheme: 'ag-theme-balham'
    },
    params_contacts: {
        only_active:true,
        filter: "",
        paginate: false
    },
    payload:{
        branchoffice_id: null,
        voucherType_id: null,
        num_doc: null,
        prefix: null,
        date: formatDateToYYYYMMDDHHMMSS (new Date()),
        contact_id: null,
        city_id: null,
        document_id: null,
        user_id: null,
        document_transaction: {
            id: null,
            account_id: null,
            affects_document_id: null,
            document_payment_id: null,
            observation: "",
            contact_id: 0,
            no_doc: null,
            value: 0,
            base_value: 0,
            order: 1,
            projects_column_visible: 0,
            contact_column_visible: true,
            cost_center_column_visible: false,
            base_value_column_visible: false,
            manage_document: false,
            validation_no_doc: null,
            account_code: "",
            account_name: "",
            tax_id: null,
            payment_column_visible: false,
            manage_bank_document: false,
            commissionable_concept: false,
            debit_credit: null,
            id_document_transactions: null
        },
        document_transactions: [],
        total_debit: null,
        total_credit: null,
        modal_loading:false,
        update_document_payments_methods:[],
    },
    show_pdf :false,
    file_name :null,
}



// WEBPACK FOOTER //
// ./src/modules/balance_reconciliation/state.js